<template>
  <div class="row"
       data-testid="audit-container">
    <div class="col-md-12">
      <AuditsTable
          data-testid="audits-table"
          model_alias="line"
          :model_id="campaign_id"
          :action_filters="AuditConfig.actionFilters"
          :text_configs="AuditConfig.textConfigs"
          :filter_options="date_filter"
          ref="auditTable"
      >Line Activity Audit Log
        <template #user-selector="{onUserFilterChange}">
          <user-selector
            data-testid="user-filter"
            placeholder="Search Agent" 
            @change="onUserFilterChange"
          ></user-selector>
        </template>
        <template #date-selector>
          <date-selector 
            data-testid="date-filter"
            class="filter-select-audits" 
            :disable_default_report_period="true">
          </date-selector>
        </template>
      </AuditsTable>
    </div>
  </div>
</template>

<script>
import AuditsTable from "../../../../../../public/vendor/auditable/audits-table.vue";
import DateSelector from "../../../components/date-selector.vue";
import {mapGetters} from "vuex";
import * as AuditConfig from "../../../constants/audits/line/audit-config";

export default {
  name: 'line-audit',

  components: {
    DateSelector,
    AuditsTable,
  },

  computed: {
    ...mapGetters({
      filter_options: 'getFilter'
    }),
  },

  props: {
    campaign_id: {required: true},
  },

  data() {
    return {
      date_filter: {
        from_date: null,
        to_date: null
      },
      AuditConfig
    }
  },

  methods: {
    update() {
      this.$refs.auditTable?.getAudits()
    }
  },

  watch: {
    'filter_options.from_date': {
      handler(new_value) {
        const newUtcValue = this.$options.filters.fixDateTimeToUTC(new_value)
        if (this.date_filter.from_date !== newUtcValue) {
          this.date_filter.from_date = newUtcValue
        }
      },
      immediate: true
    },

    'filter_options.to_date': {
      handler(new_value) {
        const newUtcValue = this.$options.filters.fixDateTimeToUTC(new_value)
        if (this.date_filter.to_date !== newUtcValue) {
          this.date_filter.to_date = newUtcValue
        }
      },
      immediate: true
    }
  }
}
</script>
